/* import __COLOCATED_TEMPLATE__ from './timeline-toggle.hbs'; */
import { action, set } from '@ember/object';
import Component from '@glimmer/component';
import styles from './timeline-toggle.module.scss';

export default class SiteBillingAccountHistoryCellsTimelineToggle extends Component {
  styles = styles;

  isTimelineVisible = false;

  @action
  toggleTimeline() {
    if (this.isTimelineVisible) {
      set(this, 'isTimelineVisible', false);
    } else {
      set(this, 'isTimelineVisible', true);
    }

    if (this.args.onToggle) {
      this.args.onToggle(this.isTimelineVisible, this.args.item);
    }
  }

  get shouldShowTimelineToggle() {
    const item = this.args.item;

    return (
      item.constructor.modelName === 'appointment' ||
      item.constructor.modelName === 'group-appointment'
    );
  }
}
